// package: asset
// file: asset-mgmt/assetManagement.proto

var asset_mgmt_assetManagement_pb = require("../asset-mgmt/assetManagement_pb");
var asset_util_pb = require("../asset/util_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var AssetManagementService = (function () {
  function AssetManagementService() {}
  AssetManagementService.serviceName = "asset.AssetManagementService";
  return AssetManagementService;
}());

AssetManagementService.GetListAssetNode = {
  methodName: "GetListAssetNode",
  service: AssetManagementService,
  requestStream: false,
  responseStream: false,
  requestType: asset_mgmt_assetManagement_pb.GetListAssetNodeRequest,
  responseType: asset_mgmt_assetManagement_pb.AssetNodeListResponse
};

AssetManagementService.UploadListAsset = {
  methodName: "UploadListAsset",
  service: AssetManagementService,
  requestStream: false,
  responseStream: false,
  requestType: asset_mgmt_assetManagement_pb.UploadListAssetRequest,
  responseType: asset_util_pb.Empty
};

exports.AssetManagementService = AssetManagementService;

function AssetManagementServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AssetManagementServiceClient.prototype.getListAssetNode = function getListAssetNode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AssetManagementService.GetListAssetNode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AssetManagementServiceClient.prototype.uploadListAsset = function uploadListAsset(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AssetManagementService.UploadListAsset, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AssetManagementServiceClient = AssetManagementServiceClient;

